import type { ExtractPropTypes, PropType } from 'vue';
import type SplitPane from './split-pane.vue';

export const SplitPaneProps = {
  splitSet: {
    type: Object as PropType<{
      minPercent: number;
      defaultPercent: number;
      split: 'vertical' | 'horizontal';
    }>,
    default: () => ({
      minPercent: 10,
      defaultPercent: 50,
      split: 'vertical',
    }),
  },
};

export type SplitPanePropsType = ExtractPropTypes<typeof SplitPaneProps>;
export type SplitPaneInstance = InstanceType<typeof SplitPane>;
